// // src/pages/CollectionReport.jsx
// import React, { useState, useEffect } from "react";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import axios from "axios";
// import "../assets/Loan/CollectionReport.css";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// const API_URL = "https://payyug.in/api/loan-emi/";
// const superAdminId = Number(localStorage.getItem("userId")) || 0;

// const CollectionReport = () => {
//   const [collections, setCollections] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [count,setcount]=useState(0);
//   const [company, setCompany] = useState(null);

//   const dispatch = useDispatch();
//   const { profile } = useSelector((state) => state.userProfile);

//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // 🔹 Fetch Data
//   useEffect(() => {
//     const superAdminId = Number(localStorage.getItem("userId")) || 0;

//     // const fetchCollections = async () => {
//     //   try {
//     //     setLoading(true);
//     //     const res = await axios.get(
//     //       `${API_URL}collection-sheet?branchId=${superAdminId}`
//     //     );
//     //     if (res.data && res.data.collections) {
//     //       setCollections(res.data.collections);
//     //     }
//     //   } catch (error) {
//     //     console.error("Error fetching collection report:", error);
//     //   } finally {
//     //     setLoading(false);
//     //   }
//     // };

//     const fetchCollections = async (page = currentPage) => {
//           try {
//              setLoading(true);
//              const res = await axios.get(
//               `https://payyug.in/api/group-loan/emi/collection-report`, {
//                  params: {
//                   superAdminId:profile.superAdminId,
//                   officerId:profile.id,
//                   page,
//                   limit:rowsPerPage,
//                 }
//             });

//             console.log("emis data", res);
//             setCollections(res.data?.data || []);
//             setTotalPages(res.data.pagination.totalPages || 1);
//             setcount(res.data.pagination.totalRecords)
//           } catch (err) {
//             console.error("Fetch Error:", err);
//           }
//           finally{
//              setLoading(false);
//           }
//         };

//     const fetchCompany = async () => {
//       try {
//         const res = await fetch(
//           `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
//         );
//         const data = await res.json();
//         if (res.ok && data) {
//           if (data.logo)
//             data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//           setCompany(data);
//         }
//       } catch (err) {
//         console.error("Failed to fetch company details", err);
//       }
//     };

//     fetchCollections();
//     fetchCompany();
//   }, [profile?.superAdminId,currentPage,rowsPerPage]);
//   // console.log(profile);

//   // 🔹 Pagination
//   // const totalPages = Math.ceil(collections.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = collections;
//   // collections.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () =>
//     currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // 🔹 ✅ Total Calculation
//   const totals = currentData.reduce(
//     (acc, c) => {
//       acc.emiAmount += c.emiAmount || 0;
//       acc.principal += c.principalComponent || 0;
//       acc.interest += c.interestComponent || 0;
//       acc.outstanding += c.outstanding || 0;
//       return acc;
//     },
//     { emiAmount: 0, principal: 0, interest: 0, outstanding: 0 }
//   );

//   // 🔹 Main PDF
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(16);
//     doc.text("Company Collection Report", 14, 18);

//     const tableColumn = [
//       "#",
//       "Customer Name",
//       "Loan Number",
//       "EMI Number",
//       "EMI Amount",
//       "Principal",
//       "Interest",
//       "Outstanding",
//       "Due Date",
//       "Payment Date",
//       "Status",
//     ];

//     const tableRows = currentData.map((c, index) => [
//       startIndex + index + 1,
//       c.customerName,
//       c.loanNumber,
//       c.emiNumber,
//       `Rs. ${c.emiAmount.toLocaleString()}`,
//       `Rs. ${c.principalComponent.toLocaleString()}`,
//       `Rs. ${c.interestComponent.toLocaleString()}`,
//       `Rs. ${c.outstanding.toLocaleString()}`,
//       new Date(c.dueDate).toLocaleDateString("en-IN"),
//       c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
//       c.status.toUpperCase(),
//     ]);

//     // ✅ Add totals row in PDF
//     tableRows.push([
//       "",
//       "",
//       "",
//       "Total:",
//       `Rs. ${totals.emiAmount.toLocaleString()}`,
//       `Rs. ${totals.principal.toLocaleString()}`,
//       `Rs. ${totals.interest.toLocaleString()}`,
//       `Rs. ${totals.outstanding.toLocaleString()}`,
//       "",
//       "",
//       "",
//     ]);

//     autoTable(doc, {
//       startY: 28,
//       head: [tableColumn],
//       body: tableRows,
//       theme: "grid",
//       headStyles: {
//         fillColor: [0, 0, 0],
//         textColor: [255, 255, 255],
//         fontStyle: "bold",
//       },
//       styles: {
//         font: "helvetica",
//         fontSize: 9,
//         cellPadding: 3,
//         lineColor: [0, 0, 0],
//         lineWidth: 0.1,
//         textColor: [0, 0, 0],
//       },
//       alternateRowStyles: { fillColor: [245, 245, 245] },
//     });

//     const pageCount = doc.internal.getNumberOfPages();
//     for (let i = 1; i <= pageCount; i++) {
//       doc.setPage(i);
//       doc.setFontSize(8);
//       doc.setTextColor(100);
//       doc.text(
//         `Page ${i} of ${pageCount}`,
//         doc.internal.pageSize.getWidth() - 30,
//         doc.internal.pageSize.getHeight() - 10
//       );
//       doc.text(
//         "Generated by Collection System",
//         14,
//         doc.internal.pageSize.getHeight() - 10
//       );
//     }

//     doc.save("Collection_Report.pdf");
//   };

//   // 🔹 Individual Slip (unchanged)
//   const handleDownloadSlip = (data) => {
//     const doc = new jsPDF("p", "pt", "a5");
//     const pageWidth = doc.internal.pageSize.getWidth();
//     const margin = 20;
//     let y = margin;

//     try {
//       if (company?.logoUrl) doc.addImage(company.logoUrl, "PNG", margin, y, 50, 50);
//     } catch {}

//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(14);
//     doc.text(company?.name || "Company Name", margin + 60, y + 20);

//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(9);
//     doc.text(`Address: ${company?.address || "-"}`, margin + 60, y + 50);

//     y += 95;
//     doc.line(margin, y, pageWidth - margin, y);
//     y += 10;

//     doc.setFont("helvetica", "bold");
//     doc.text("Customer Details", margin, y);
//     y += 8;
//     autoTable(doc, {
//       startY: y,
//       theme: "plain",
//       styles: { fontSize: 9, cellPadding: 3 },
//       body: [
//         [{ content: `Name: ${data.customerName || "-"}` }],
//         [{ content: `Loan Number: ${data.loanNumber || "-"}` }],
//         [{ content: `EMI Number: ${data.emiNumber || "-"}` }],
//       ],
//     });

//     y = doc.lastAutoTable.finalY + 10;
//     doc.setFont("helvetica", "bold");
//     doc.text("Transaction Details", margin, y);
//     y += 8;

//     autoTable(doc, {
//       startY: y,
//       theme: "plain",
//       styles: { fontSize: 9, cellPadding: 3 },
//       body: [
//         [
//           { content: `EMI Amount: Rs. ${data.emiAmount?.toLocaleString() || "-"}` },
//           { content: `Principal: Rs. ${data.principalComponent?.toLocaleString() || "-"}` },
//         ],
//         [
//           { content: `Interest: Rs. ${data.interestComponent?.toLocaleString() || "-"}` },
//           { content: `Outstanding: Rs. ${data.outstanding?.toLocaleString() || "-"}` },
//         ],
//       ],
//     });

//     doc.save(`LoanSlip_${data.customerName || "Customer"}.pdf`);
//   };

//   return (
//     <div className="CollectionReport-wrapper">
//       <h1 className="CollectionReport-title">📋 Collection Report</h1>

//       {/* Controls */}
//       <div className="CollectionReport-controls">
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//           </select>{" "}
//           entries
//         </label>

//         <button className="filter-btn" onClick={handleDownloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       {/* Table */}
//       <div className="CollectionReport-table-container">
//         {loading ? (
//           <p className="CollectionReport-loading">⏳ Loading data...</p>
//         ) : (
//           <table className="CollectionReport-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Customer Name</th>
//                 <th>Loan Number</th>
//                 <th>EMI Number</th>
//                 <th>EMI Amount</th>
//                 <th>Principal</th>
//                 <th>Interest</th>
//                 <th>Outstanding</th>
//                 <th>Due Date</th>
//                 <th>Payment Date</th>
//                 <th>Status</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentData.length === 0 ? (
//                 <tr>
//                   <td colSpan="12" className="CollectionReport-empty">
//                     ✅ No records found
//                   </td>
//                 </tr>
//               ) : (
//                 currentData.map((c, idx) => (
//                   <tr key={c.id}>
//                     <td>{startIndex + idx + 1}</td>
//                     <td>{c.customerName}</td>
//                     <td>{c.loanNumber}</td>
//                     <td>{c.emiNumber}</td>
//                     <td>Rs. {c.emiAmount.toLocaleString()}</td>
//                     <td>Rs. {c.principalComponent.toLocaleString()}</td>
//                     <td>Rs. {c.interestComponent.toLocaleString()}</td>
//                     <td>Rs. {c.outstanding.toLocaleString()}</td>
//                     <td>{new Date(c.dueDate).toLocaleDateString("en-IN")}</td>
//                     <td>
//                       {c.paymentDate
//                         ? new Date(c.paymentDate).toLocaleDateString("en-IN")
//                         : "-"}
//                     </td>
//                     <td>
//                       <span
//                         className={`CollectionReport-status ${
//                           c.status === "pending" ? "pending" : "paid"
//                         }`}
//                       >
//                         {c.status}
//                       </span>
//                     </td>
//                     <td>
//                       <button
//                         className="slip-btn-collection-report-branch"
//                         onClick={() => handleDownloadSlip(c)}
//                       >
//                         🧾 Slip
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>

//             {/* ✅ Totals Row */}
//             {!loading && currentData.length > 0 && (
//               <tfoot>
//                 <tr className="CollectionReport-total-row">
//                   <td colSpan="4" style={{ textAlign: "right", fontWeight: "bold" }}>
//                     Total:
//                   </td>
//                   <td style={{ fontWeight: "bold" }}>
//                     Rs. {totals.emiAmount.toLocaleString()}
//                   </td>
//                   <td style={{ fontWeight: "bold" }}>
//                     Rs. {totals.principal.toLocaleString()}
//                   </td>
//                   <td style={{ fontWeight: "bold" }}>
//                     Rs. {totals.interest.toLocaleString()}
//                   </td>
//                   <td style={{ fontWeight: "bold" }}>
//                     Rs. {totals.outstanding.toLocaleString()}
//                   </td>
//                   <td colSpan="4"></td>
//                 </tr>
//               </tfoot>
//             )}
//           </table>
//         )}
//       </div>

//       {/* Pagination */}
//       {!loading && (
//         <div className="CollectionReport-pagination">
//           <button
//             className="pagination-btn"
//             onClick={handlePrev}
//             disabled={currentPage === 1}
//           >
//             ⬅ Prev
//           </button>
//           <span className="pagination-info">
//             Page {currentPage} of {totalPages}
//           </span>
//           <button
//             className="pagination-btn"
//             onClick={handleNext}
//             disabled={currentPage === totalPages}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CollectionReport;



// src/pages/CollectionReport.jsx
import React, { useState, useEffect, useRef } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import "../assets/Loan/CollectionReport.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useNavigate } from "react-router-dom";

const API_URL = "https://payyug.in/api/loan-emi/";
const superAdminId = Number(localStorage.getItem("userId")) || 0;

const CollectionReport = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [company, setCompany] = useState(null);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [selectedReceipts, setSelectedReceipts] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
  const slipRef = useRef(null);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // 🔹 Fetch Data
  useEffect(() => {
    const superAdminId = Number(localStorage.getItem("userId")) || 0;

    const fetchCollections = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${API_URL}collection-sheet?branchId=${superAdminId}`,
        );
        if (res.data && res.data.collections) {
          setCollections(res.data.collections);
        }
      } catch (error) {
        console.error("Error fetching collection report:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo)
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          setCompany(data);
        }
      } catch (err) {
        console.error("Failed to fetch company details", err);
      }
    };

    fetchCollections();
    fetchCompany();
  }, [profile?.superAdminId]);

  // 🔹 Pagination
  // const totalPages = Math.ceil(collections.length / rowsPerPage);
  // const startIndex = (currentPage - 1) * rowsPerPage;
  // const currentData = collections.slice(startIndex, startIndex + rowsPerPage);

  // 🔹 Search Filter
const filteredCollections = collections.filter((c) => {
  if (!searchQuery.trim()) return true;

  const query = searchQuery.toLowerCase();

  return (
    c.customerName?.toLowerCase().includes(query) ||
    c.loanNumber?.toLowerCase().includes(query) 
    // c.emiNumber?.toString().toLowerCase().includes(query) ||
    // c.status?.toLowerCase().includes(query) ||
    // c.emiAmount?.toString().includes(query) ||
    // c.outstanding?.toString().includes(query) ||
    // c.paymentDate
    //   ?.toString()
    //   .toLowerCase()
    //   .includes(query)
  );
});

useEffect(() => {
  setCurrentPage(1);
}, [searchQuery]);

// 🔹 Pagination after filtering
const totalPages = Math.ceil(
  filteredCollections.length / rowsPerPage
);

const startIndex = (currentPage - 1) * rowsPerPage;

const currentData = filteredCollections.slice(
  startIndex,
  startIndex + rowsPerPage
);

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);

    useEffect(() => {
    setSelectedReceipts([]);
  }, [currentPage, rowsPerPage]);

  // 🔹 ✅ Total Calculation
  const totals = currentData.reduce(
    (acc, c) => {
      acc.emiAmount += c.emiAmount || 0;
      acc.principal += c.principalComponent || 0;
      acc.interest += c.interestComponent || 0;
      acc.outstanding += c.outstanding || 0;
      return acc;
    },
    { emiAmount: 0, principal: 0, interest: 0, outstanding: 0 },
  );

    /* ---------------- RECEIPT NAVIGATION ---------------- */
  const handleViewCollectionReceipt = (data) => {
    navigate(`/Loan/ViewLoanCollectionReceipt`, {
      state: { collectionReceipt: data},
    });
    // console.log("collection ",data)
  };

    /* ---------------- SELECT ALL LOGIC ---------------- */
  const isAllSelected =
    currentData.length > 0 &&
    currentData.every((c) =>
      selectedReceipts.some((r) => r.id === c.id)
    );

  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedReceipts(currentData);
    } else {
      setSelectedReceipts([]);
    }
  };

  // 🔹 Main PDF
  const handleDownloadPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // ================= LOGO =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;

    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;

    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;

    // Draw circle
    doc.circle(centerX, centerY, radius);

    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(
              reader.result,
              "PNG",
              logoX,
              logoY,
              logoSize,
              logoSize,
            );
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }

    // ================= COMPANY NAME (AUTO WRAP) =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    const nameX = logoX + logoSize + 5;
    const nameY = 18;
    const nameMaxWidth = pageWidth - nameX - 15;

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth,
    );

    doc.text(companyNameText, nameX, nameY);

    // Calculate Y after company name
    let currentY = nameY + companyNameText.length * 6;

    // ================= COMPANY DETAILS =================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    const detailX = nameX;
    const detailMaxWidth = nameMaxWidth;

    // Address
    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      detailMaxWidth,
    );
    doc.text(addressText, detailX, currentY);
    currentY += addressText.length * 5;

    // Email
    const emailText = doc.splitTextToSize(
      `Email: ${company?.email || "-"}`,
      detailMaxWidth,
    );
    doc.text(emailText, detailX, currentY);
    currentY += emailText.length * 5;

    // Phone
    const phoneText = doc.splitTextToSize(
      `Phone: ${company?.contact || "-"}`,
      detailMaxWidth,
    );
    doc.text(phoneText, detailX, currentY);
    currentY += phoneText.length * 5;

    // Divider
    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

    // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Collection Report", pageWidth / 2, currentY + 14, {
      align: "center",
    });

    // ================= TABLE =================
    const tableColumn = [
      "#",
      "Customer Name",
      "Loan No",
      "EMI No",
      "EMI Amt",
      "Principal",
      "Interest",
      "Outstanding",
      "Due Date",
      "Pay Date",
      "Status",
    ];

    const tableRows = currentData.map((c, index) => [
      startIndex + index + 1,
      c.customerName,
      c.loanNumber,
      c.emiNumber,
      `Rs. ${c.emiAmount.toLocaleString("en-IN")}`,
      `Rs. ${c.principalComponent.toLocaleString("en-IN")}`,
      `Rs. ${c.interestComponent.toLocaleString("en-IN")}`,
      `Rs. ${c.outstanding.toLocaleString("en-IN")}`,
      new Date(c.dueDate).toLocaleDateString("en-IN"),
      c.paymentDate ? new Date(c.paymentDate).toLocaleDateString("en-IN") : "-",
      c.status.toUpperCase(),
    ]);

    const totalRow = [
      {
        content: "Total",
        colSpan: 4,
        styles: { halign: "right", fontStyle: "bold" },
      },
      {
        content: totals.emiAmount.toLocaleString("en-IN"),
        styles: { fontStyle: "bold" },
      },
      {
        content: totals.principal.toLocaleString("en-IN"),
        styles: { fontStyle: "bold" },
      },
      {
        content: totals.interest.toLocaleString("en-IN"),
        styles: { fontStyle: "bold" },
      },
      {
        content: totals.outstanding.toLocaleString("en-IN"),
        styles: { fontStyle: "bold" },
      },
      "",
      "",
      "",
      "",
    ];

    autoTable(doc, {
      startY: currentY + 20,
      head: [tableColumn],
      body: tableRows,
      foot: [totalRow],

      showFoot: "lastPage", // 🔥 IMPORTANT LINE

      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 3,
        halign: "center",
      },
      headStyles: {
        fontStyle: "bold",
        fontSize: 7,
      },
      footStyles: {
        fillColor: [220, 220, 220],
        textColor: 20,
        fontStyle: "bold",
        fontSize: 8,
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },

      didDrawPage: function () {
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        doc.setDrawColor(0);
        doc.setLineWidth(0.2);

        // Page border on EVERY page
        doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
      },
    });

    // ================= FOOTER =================
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
      doc.text("Generated by Collection System", 14, pageHeight - 10);
    }

    doc.save("Collection_Report.pdf");
  };

  // 🔹 Individual Slip (unchanged)
  // const handleDownloadSlip = (data) => {
  //   const doc = new jsPDF("p", "pt", "a5");
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const margin = 20;
  //   let y = margin;

  //   try {
  //     if (company?.logoUrl)
  //       doc.addImage(company.logoUrl, "PNG", margin, y, 50, 50);
  //   } catch {}

  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(14);
  //   doc.text(company?.name || "Company Name", margin + 60, y + 20);

  //   doc.setFont("helvetica", "normal");
  //   doc.setFontSize(9);
  //   doc.text(`Address: ${company?.address || "-"}`, margin + 60, y + 50);

  //   y += 95;
  //   doc.line(margin, y, pageWidth - margin, y);
  //   y += 10;

  //   doc.setFont("helvetica", "bold");
  //   doc.text("Customer Details", margin, y);
  //   y += 8;
  //   autoTable(doc, {
  //     startY: y,
  //     theme: "plain",
  //     styles: { fontSize: 9, cellPadding: 3 },
  //     body: [
  //       [{ content: `Name: ${data.customerName || "-"}` }],
  //       [{ content: `Loan Number: ${data.loanNumber || "-"}` }],
  //       [{ content: `EMI Number: ${data.emiNumber || "-"}` }],
  //     ],
  //   });

  //   y = doc.lastAutoTable.finalY + 10;
  //   doc.setFont("helvetica", "bold");
  //   doc.text("Transaction Details", margin, y);
  //   y += 8;

  //   autoTable(doc, {
  //     startY: y,
  //     theme: "plain",
  //     styles: { fontSize: 9, cellPadding: 3 },
  //     body: [
  //       [
  //         {
  //           content: `EMI Amount: Rs. ${data.emiAmount?.toLocaleString() || "-"}`,
  //         },
  //         {
  //           content: `Principal: Rs. ${data.principalComponent?.toLocaleString() || "-"}`,
  //         },
  //       ],
  //       [
  //         {
  //           content: `Interest: Rs. ${data.interestComponent?.toLocaleString() || "-"}`,
  //         },
  //         {
  //           content: `Outstanding: Rs. ${data.outstanding?.toLocaleString() || "-"}`,
  //         },
  //       ],
  //     ],
  //   });

  //   doc.save(`LoanSlip_${data.customerName || "Customer"}.pdf`);
  // };

  // const handlePrintThermalSlip = async () => {
  //   if (!slipRef.current) return;

  //   const { jsPDF } = await import("jspdf");
  //   const html2canvas = (await import("html2canvas")).default;

  //   // 1️⃣ Render slip to canvas
  //   const canvas = await html2canvas(slipRef.current, {
  //     scale: 3,
  //     backgroundColor: "#ffffff",
  //   });
  //   const imgData = canvas.toDataURL("image/png");

  //   // 2️⃣ Prepare PDF (thermal size)
  //   const pdfWidth = 58; // mm
  //   const imgWidth = pdfWidth;
  //   const imgHeight = (canvas.height * pdfWidth) / canvas.width;

  //   const pdf = new jsPDF({
  //     orientation: "portrait",
  //     unit: "mm",
  //     format: [pdfWidth, imgHeight],
  //   });
  //   pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

  //   // 3️⃣ Try to open print window
  //   try {
  //     const printWindow = window.open("", "_blank", "width=1000,height=600");

  //     printWindow.document.write(`
  //       <html>
  //         <head>
  //           <title>Print Slip</title>
  //           <style>
  //             @page { size: 58mm auto; margin:0; }
  //             body { margin:0; padding:0; text-align:center; }
  //             img { width:58mm; max-width:58mm; }
  //           </style>
  //         </head>
  //         <body>
  //           <img src="${imgData}" />
  //         </body>
  //       </html>
  //     `);

  //     printWindow.document.close();

  //     // Wait for print window to load
  //     printWindow.onload = () => {
  //       printWindow.focus();
  //       printWindow.print();
  //       // Optional: close after printing
  //       setTimeout(() => printWindow.close(), 500);
  //     };
  //   } catch (err) {
  //     // 4️⃣ Fallback → Download PDF
  //     pdf.save(`LoanSlip_${selectedLoan.customerName || "Customer"}.pdf`);
  //   }
  // };

  return (
    <div className="CollectionReport-wrapper">
      <h1 className="CollectionReport-title">📋 Collection Report</h1>

      {/* Controls */}
      <div className="CollectionReport-controls">
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={50000}>All</option>
          </select>{" "}
          entries
        </label>

        <input
    type="search"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => {
      setSearchQuery(e.target.value);
      setCurrentPage(1);
    }}
    className="CollectionReport-search"
  />

        <div className="">
          <button
          className="filter-btn"
          disabled={selectedReceipts.length === 0}
          onClick={() =>
            navigate("/Loan/ViewLoanCollectionReceipt", {
              state: { receipts: selectedReceipts },
            })
          }
        >
          🧾 Bulk Receipt
        </button>
        <button className="filter-btn" onClick={handleDownloadPDF}>
          📄 Download PDF
        </button>
        </div>
      </div>

      {/* Table */}
      <div className="CollectionReport-table-container">
        {loading ? (
          <p className="CollectionReport-loading">⏳ Loading data...</p>
        ) : (
          <table className="CollectionReport-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Customer Name</th>
                <th>Loan Number</th>
                <th>EMI Number</th>
                <th>EMI Amount</th>
                <th>Principal</th>
                <th>Interest</th>
                <th>Outstanding</th>
                <th>Due Date</th>
                <th>Payment Date</th>
                <th>Status</th>
                <th>Single Receipt</th>
                <th
                  style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection:"column",
                    alignContent: "center",
                  }}
                >
                  Select For Bulk Receipt
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={(e) => toggleSelectAll(e.target.checked)}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td colSpan="12" className="CollectionReport-empty">
                    ✅ No records found
                  </td>
                </tr>
              ) : (
                currentData.map((c, idx) =>{
                  const nextemi=idx<currentData.length-1?currentData[idx+1]:null;
                return (
                  
                  <tr key={c.id}>
                    <td>{startIndex + idx + 1}</td>
                    <td>{c.customerName}</td>
                    <td>{c.loanNumber}</td>
                    <td>{c.emiNumber}</td>
                    <td>Rs. {c.emiAmount.toLocaleString()}</td>
                    <td>Rs. {c.principalComponent.toLocaleString()}</td>
                    <td>Rs. {c.interestComponent.toLocaleString()}</td>
                    <td>Rs. {c.outstanding.toLocaleString()}</td>
                    <td>{new Date(c.dueDate).toLocaleDateString("en-GB").replaceAll("/","-")}</td>
                    <td>
                      {c.paymentDate
                        ? new Date(c.paymentDate).toLocaleDateString("en-GB").replaceAll("/","-")
                        : "-"}
                    </td>
                    <td>
                      <span
                        className={`CollectionReport-status ${
                          c.status === "pending" ? "pending" : "paid"
                        }`}
                      >
                        {c.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="slip-btn-collection-report-branch"
                        onClick={() => handleViewCollectionReceipt(c)}
                      >
                        Receipt
                      </button>
                    </td>
                    <td style={{textAlign:"center"}}>
                      <input
                      type="checkbox"
                      checked={selectedReceipts.some(
                        (r) => r.id === c.id
                      )}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedReceipts((p) => [...p, c]);
                        } else {
                          setSelectedReceipts((p) =>
                            p.filter((r) => r.id !== c.id)
                          );
                        }
                      }}
                    />
                    </td>

                    {/* <td>
                      <div style={{display:"flex",gap:"10px"}}>
                      <button
                        className="slip-btn-collection-report-branch"
                        onClick={() => handleDownloadSlip(c)}
                      >
                       📄 PDF
                      </button>
                      <button
                        className="slip-btn-collection-report-branch"
                        onClick={() =>{
                          setSelectedLoan(c)
                           handlePrintThermalSlip()
                        }
                      }
                      >
                        🧾 Slip
                      </button>
                      </div>
                    </td> */}
                  </tr>
                )})
              )}
            </tbody>

            {/* ✅ Totals Row */}
            {!loading && currentData.length > 0 && (
              <tfoot>
                <tr className="CollectionReport-total-row">
                  <td
                    colSpan="4"
                    style={{ textAlign: "right", fontWeight: "bold" }}
                  >
                    Total:
                  </td>
                  <td style={{ fontWeight: "bold" }}>
                    Rs. {totals.emiAmount.toLocaleString()}
                  </td>
                  <td style={{ fontWeight: "bold" }}>
                    Rs. {totals.principal.toLocaleString()}
                  </td>
                  <td style={{ fontWeight: "bold" }}>
                    Rs. {totals.interest.toLocaleString()}
                  </td>
                  <td style={{ fontWeight: "bold" }}>
                    Rs. {totals.outstanding.toLocaleString()}
                  </td>
                  <td colSpan="5"></td>
                </tr>
              </tfoot>
            )}
          </table>
        )}
      </div>

      {/* Pagination */}
      {!loading && (
        <div className="CollectionReport-pagination">
          <button
            className="pagination-btn"
            onClick={handlePrev}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>
          <span className="pagination-info">
            Page {currentPage} of {totalPages}
          </span>
          <button
            className="pagination-btn"
            onClick={handleNext}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}

      {/* Hidden thermal print container */}
      <div style={{ position: "absolute", left: "-10000px" }}>
        <div
          ref={slipRef}
          style={{
            width: "230px", // 58mm thermal printer width
            padding: "10px",
            border: "1px solid #ccc",
            fontFamily: "Courier New, monospace",
            fontSize: "12px",
            lineHeight: "1.2",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {company ? company.name : "--"}
            </div>
            <div
              style={{
                textAlign: "center",
                fontWeight: "semi-bold",
                fontSize: "9px",
              }}
            >
              <b>Contact No.:</b> {company ? company.contact : "--"}
            </div>
            <div
              style={{
                textAlign: "center",
                fontWeight: "semi-bold",
                fontSize: "9px",
              }}
            >
              <b>Address.:</b> {company ? company.address : "--"}
            </div>
          </div>

          <div
            style={{
              textAlign: "center",
              marginTop: "10px",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            Collection Slip
          </div>

          <div
            style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}
          ></div>

          <div>
            <b>Name:</b> {selectedLoan?.customerName || "--"}
          </div>
          <div>
            <b>Loan Number:</b> {selectedLoan?.loanNumber || "--"}
          </div>
          <div>
            <b>Emi Number:</b> {selectedLoan?.emiNumber || "--"}
          </div>
          <div>
            <b>Emi Amount:</b> Rs. {selectedLoan?.emiAmount || "--"}
          </div>
          <div>
            <b>Interest:</b> Rs. {selectedLoan?.interestComponent || "--"}
          </div>
          <div>
            <b>Principal:</b> Rs. {selectedLoan?.principalComponent || "--"}
          </div>
          <div>
            <b>Outstanding:</b> Rs. {selectedLoan?.outstanding || "--"}
          </div>

          <div
            style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}
          ></div>

          <div style={{ textAlign: "center" }}>Thank you!</div>
          <div style={{ textAlign: "center" }}>
            --- {company ? company.name.split(" ")[0] : "End of "} Slip ---
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollectionReport;
